var parent = require(106);

module.exports = parent;
